const unobserve = (element: Element, observer: IntersectionObserver) => {
  observer.unobserve(element)
  if (element.getAttribute('data-animation-once') !== 'true') {
    const time = element.getAttribute('data-animation-time')
    const delay = element.getAttribute('data-animation-delay')
    const timeout = Number(time) + Number(delay)
    setTimeout(() => {
      observer.observe(element)
    }, timeout)
  }
}

const startAnimation = (element: Element) => {
  element.setAttribute('data-animation-state', 'running')
}

const params = new URLSearchParams(window.location.search)
const disabledAnimations = params.get('animations') == 'skip'
window.addEventListener('DOMContentLoaded', function () {
  if (disabledAnimations) {
    const allAnimatedElements = document.querySelectorAll('[data-animation-type]')
    allAnimatedElements.forEach((el) => {
      el.setAttribute('data-animation-type', 'none')
    })
  }
})

const setupStyleGuideAnimatedNodes = () => {
  if (disabledAnimations) return
  const styleGuideAnimationNode = JSON.parse(
    document.getElementById('cf-lander-serialized-style-guide-animation-node')?.textContent ?? '{}'
  )
  document.querySelectorAll('[data-style-guide-animation]').forEach((element) => {
    const style = element.getAttribute('data-style-guide-animation')
    const selectedAnimation =
      styleGuideAnimationNode.selectors[`.elPageContent [data-style-guide-animation="${style}"]`]
    element.setAttribute('data-animation-type', selectedAnimation.attrs['data-animation-type'])
    element.setAttribute('data-animation-trigger', selectedAnimation.attrs['data-animation-trigger'])
  })
}

$(document).ready(function () {
  const runAllAnimations = function () {
    setupStyleGuideAnimatedNodes()
    const scrollElements = document.querySelectorAll('[data-animation-trigger="scroll"]')
    const loadElements = document.querySelectorAll('[data-animation-trigger="load"]')

    const config = {
      rootMargin: '50px 20px 75px 30px',
      threshold: [0, 0.25, 0.75, 1],
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          if (entry.target.getAttribute('data-animation-state') !== 'running') {
            unobserve(entry.target, observer)
            startAnimation(entry.target)
          }
        } else {
          entry.target.setAttribute('data-animation-state', 'off')
        }
      })
    }, config)

    scrollElements.forEach((element) => {
      observer.observe(element)
    })

    loadElements.forEach((element) => {
      startAnimation(element)
    })
  }

  if (!disabledAnimations) runAllAnimations()
})
